import React, {useEffect, useRef, useState} from 'react';

// 이미지 임포트 (실제 이미지 경로로 변경 필요)
import store01 from '../../../assets/images/about/section_02_subsection_02_item_01.png';
import store02 from '../../../assets/images/about/section_02_subsection_02_item_02.png';
import store03 from '../../../assets/images/about/section_02_subsection_02_item_03.png';
import phoneImage from "@/assets/images/about/section_02_subsection_01_item.png";

const AboutSubSection0202: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // 섹션이 화면에 보일 때만 애니메이션 적용
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          // 섹션이 화면에서 벗어났을 때
          setIsVisible(false);
        }
      },
      {
        threshold: window.innerWidth <= 1024 ? 0.08 : 0.2, // 섹션이 20% 이상 보일 때 트리거
        rootMargin: '-50px' // 뷰포트 경계에서 50px 안쪽에서 트리거
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <div ref={sectionRef} className={`container text-black py-[170px] md:py-[256px] transition-all duration-[1500ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
      <div className="hidden lg:block mx-auto">
        {/* 메인 콘텐츠 - 왼쪽 이미지, 오른쪽 텍스트 */}
        <div className="flex flex-row items-center justify-between lg:gap-8 xl:gap-16 2xl:gap-32">
          {/* 왼쪽: 이미지 */}
          <div className="w-1/2 2xl:w-1/2">
            <img
              src={store03}
              alt="오프라인 스토어 이미지 3"
              className="w-full h-[400px] object-cover rounded-[5px]"
            />
            {/* <div className="flex gap-2 me-[4px]">
              <div className="w-3/5">
                <img
                  src={store01}
                  alt="오프라인 스토어 이미지 1"
                  className="w-full h-[348px] object-cover rounded-[5px]"
                />
              </div>
              <div className="w-4/10">
                <img
                  src={store02}
                  alt="오프라인 스토어 이미지 2"
                  className="w-full h-[348px] object-cover rounded-[5px]"
                />
              </div>
            </div> */}
          </div>

          {/* 오른쪽: 텍스트 정보 */}
          <div className="w-1/2 2xl:w-1/2">
            <div className="flex flex-col">
            {/* 섹션 제목 */}
            <p className="text-xl font-semibold mb-[72px]">
              Offline Store
            </p>
            <p className="text-40 leading-[1.4] font-bold mb-[72px]">
              직영점부터 샵인샵, 프랜차이즈까지<br/>
              오프라인 컬러렌즈 편집샵
            </p>
            <p className="text-xl font-normal leading-[1.6]">
              명동 롯데 면세점, 일본 도쿄 등 핵심 지역에 오프라인 매장을 운영 중입니다.<br/>
              브랜드별 디스플레이, 착용 비교 체험존 등 고객 중심의 오프라인 경험을 강화하고 있습니다.
            </p>
            </div>
          </div>
        </div>
      </div>
      <div className="lg:hidden mx-auto">
        {/* 메인 콘텐츠 - 왼쪽 텍스트, 오른쪽 이미지 */}
        <div className="flex flex-col items-center justify-center">
          {/* 왼쪽: 통계 정보 */}
          <p className="text-2xl md:text-4xl font-semibold mb-[30px] md:mb-[50px]">
            Offline Store
          </p>
          <span className="text-4xl md:text-6xl leading-[1.4] font-bold md:mb-4">
              직영점부터 샵인샵, 프랜차이즈까지
          </span>
          <span className="text-4xl md:text-6xl leading-[1.4] font-bold">
              오프라인 컬러렌즈 편집샵
          </span>

          <div className="flex gap-2 py-8 md:py-28 mx-16 md:mx-36">
            {/* <img
              src={store01}
              alt="오프라인 스토어 이미지 1"
              className="w-3/5 h-auto object-cover scale-y-[1.3]"
              // style={{ transform: 'scaleY(1.2)' }}
            />
            <img
              src={store02}
              alt="오프라인 스토어 이미지 2"
              className="w-2/6 h-auto object-cover scale-y-[1.3]"
              // style={{ transform: 'scaleY(1.2)' }}
            /> */}
            <img
              src={store03}
              alt="오프라인 스토어 이미지"
              className="w-5/5 h-auto"
            />
          </div>

          <p className="text-center font-normal text-2xl md:text-4xl leading-[1.6] md:mb-2">
            홍대·성수 플래그십 스토어, 일본 도쿄 등</p>
          <p className="text-center font-normal text-2xl md:text-4xl leading-[1.6] md:mb-2">
            핵심 지역에 오프라인 매장을 운영 중입니다.</p>
          <p className="text-center font-normal text-2xl md:text-4xl leading-[1.6] md:mb-2">
            브랜드별 디스플레이, 착용 비교 체험존 등</p>
          <p className="text-center font-normal text-2xl md:text-4xl leading-[1.6] md:mb-2">
            고객 중심의 오프라인 경험을 강화하고 있습니다.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutSubSection0202;